import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DocumentsState } from "../objects/documentsState";
import { DocumentBankType } from "../objects/documentType";

const initialState: DocumentsState = {
    selected_document: null
};

export const documents = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setSelectedDocument: (state: DocumentsState, action: PayloadAction<DocumentBankType | null>) => {
            state.selected_document = action.payload;
        }
    }
});

export const {
    setSelectedDocument
} = documents.actions;